// extracted by css-extract-rspack-plugin
export default {"spinner":"spinner-w4SMIk"};